import Modal, { ModalSize } from "../../../../common/components/Modal";
import { useAddToCartWizardContext } from "../AddToCartWizard";
import AtcProductInfo from "../../v2/AtcProductInfo/AtcProductInfo";
import { useFormContext } from "react-hook-form";
import { type AddToCartFormData } from "../../../hooks/useAddToCartNew";
import { Stacker } from "~/common/components/Stacker/Stacker";
import { redirectOrReload, resolveCartPageUrl } from "../../../../utils/url/urlUtils";
import { isSpecialPrice } from "~/ProductDetails/redux/productDetailsSelectors";
import { Alert } from "~/common/m3/Alert/Alert";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";
import classNames from "classnames";
import AtcProductPriceInfo from "../../v2/AtcProductPriceInfo/AtcProductPriceInfo";
import { useIsMinTabletSize, useIsMinDesktopSize } from "../../../../common/hooks/useMediaQuery";

interface Props {
  productDescriptor: ProductDescriptor;
}

export const ErrorSendingModal = ({ productDescriptor }: Props) => {
  const { closePopup, getModalProps, getMainCls, t, getCloseBtn, getActionBtn } = useAddToCartWizardContext();

  const { watch } = useFormContext<AddToCartFormData>();
  const isTablet = useIsMinTabletSize();
  const isDesktop = useIsMinDesktopSize();

  const quantity = watch("quantity");
  const priceReference = watch("priceReference");
  const price = watch("netPrice");
  const priceUnit = watch("priceUnit");
  const hasSurcharge = watch("surcharge") > 0;
  const selectedPackCode = watch("selectedPack");
  const isSpecial = isSpecialPrice(productDescriptor, selectedPackCode?.packCode ?? "");

  const action = () => redirectOrReload(resolveCartPageUrl());

  return (
    <Modal
      size={isDesktop ? ModalSize.MEDIUM : ModalSize.TABLET}
      onClose={closePopup}
      noPadding={!isTablet}
      footerClassName={classNames(!isTablet && "scha__add-to-cart-popup-footer")}
      footerChildren={
        <Stacker direction={"row"} gap={8} className={classNames(!isTablet && "w-100")}>
          {getCloseBtn(t("close"), !isTablet)}
          {getActionBtn(t("addToCartPopup.checkoutBtn"), action, true)}
        </Stacker>
      }
      {...getModalProps()}
    >
      <div className="scha__atc-popup__wrapper">
        <div className={classNames(getMainCls(), "scha__atc-popup-continer")}>
          <div className="scha__atc-popup--column-info">
            <AtcProductInfo descriptor={productDescriptor}/>
          </div>
          <div className="scha__atc-popup--column-packaging__wrapper scha__atc-popup--column-packaging">
            <div className="w-100">
              <Alert className="mb-30" severity={"error"}>
                {t("addToCartPopup.add.error")}
              </Alert>
            </div>
            <div>
              <AtcProductPriceInfo
                quantity={quantity}
                price={price}
                onChange={() => {}}
                disabled={true}
                priceUnit={priceUnit}
                priceReference={priceReference}
                onPriceReferenceChange={() => {}}
                descriptor={productDescriptor}
                hasSurcharge={hasSurcharge}
                isSpecialPrice={isSpecial}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
